<template>
  <span class="badge" :class="jobLabelClass">
    {{ job.type?.label }}
  </span>
</template>
<script>
export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },

  computed: {
    jobLabelClass() {
      switch (this.job.type?.name) {
        case 'hire_delivery':
        case 'client_delivery':
          return 'badge-primary';

        case 'third_party_movement':
          return 'badge-success';

        default:
          return 'badge-warning';
      }
    }
  }
};
</script>
